/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Front_DeskInputs */

const en_footer_front_desk = /** @type {(inputs: Footer_Front_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call us`)
};

const pl_footer_front_desk = /** @type {(inputs: Footer_Front_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadzwoń do nas`)
};

/**
* | output |
* | --- |
* | "Call us" |
*
* @param {Footer_Front_DeskInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_front_desk = /** @type {((inputs?: Footer_Front_DeskInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Front_DeskInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_footer_front_desk(inputs)
	return en_footer_front_desk(inputs)
});